import Vue from 'vue'
const basePath = resourceId => `passenger/profile_requests/${resourceId}`

export default {
  /*
   * Devuelve las solicitudes de perfil
   */
  index(params) {
    return Vue.http.get('passenger/profile_requests', {params}).then(
      response => response.data
    )
  },
  update(id, data) {
    return Vue.http.put(`passenger/profile_requests/${id}`, data,
      {headers: {'Content-Type': 'multipart/form-data'}}).then(
      response => response
    )
  },
  create(data) {
    return Vue.http.post('passenger/profile_requests', data,
      {headers: {'Content-Type': 'multipart/form-data'}}).then(
      response => response
    )
  },

  show(id, params) {
    return Vue.http.get(basePath(id), {params}).then(response => response.data.data)
  },
  /**
   * downloadFile() descarga un archivo de teddy por medio de la API
   */
  downloadFile(id, file_id) {
    const params = {
      file_id
    }

    return Vue.http
      .get(`${basePath(id)}/download_file`, {
        params,
        responseType: 'arraybuffer'
      })
      .then(response => {
        const headers = response.headers

        const fileData = response.data

        const fileType = headers.get('Content-Type')

        const fileNameParam = file_id

        if (!fileType || !fileNameParam) {
          throw new Error('Error al descargar el archivo')
        }

        // Descargar el archivo
        const fileBlob = new Blob([fileData], {
          type: fileType
        })
        const fileUrl = window.URL.createObjectURL(fileBlob)
        const fileName = fileNameParam
        const fileLink = document.createElement('a')
        fileLink.style.display = 'none'
        fileLink.href = fileUrl
        fileLink.download = fileName
        document.body.appendChild(fileLink)
        fileLink.click()
        window.URL.revokeObjectURL(fileUrl)
      })
      .catch(error => Promise.reject(error))
  }
}
